import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { API, useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Bell } from "lucide-react";
import { Link } from "react-router-dom";

export default function NotificationBell() {
  const { user } = useAuth();
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const seen = useRef(null);

  const load = async () => {
    try {
      const { data } = await axios.get(`${API}/notifications`);
      if (seen.current !== null && data.unread > seen.current) {
        const n = data.items.find(x => !x.read);
        if (n) toast.success(n.title, { description: n.body });
      }
      seen.current = data.unread;
      setData(data);
    } catch {}
  };
  useEffect(() => { if (!user) return; load(); const iv = setInterval(load, 30000); return () => clearInterval(iv); }, [user]);

  const toggle = async () => {
    const next = !open; setOpen(next);
    if (next && data.unread) { await axios.post(`${API}/notifications/read-all`, {}).catch(() => {}); seen.current = 0; setData(d => ({ ...d, unread: 0, items: d.items.map(x => ({ ...x, read: true })) })); }
  };
  if (!user) return null;

  return (
    <div className="relative">
      <button onClick={toggle} className="relative p-2 rounded-full hover:bg-white/5 transition" data-testid="notif-bell">
        <Bell className="w-5 h-5" />
        {data.unread > 0 && <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#FF1E27] text-[10px] font-bold flex items-center justify-center" data-testid="notif-badge">{data.unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto rl-card p-2 z-50 shadow-2xl" data-testid="notif-panel">
          {data.items.length === 0 && <div className="text-sm text-slate-500 p-4 text-center">Nessuna notifica</div>}
          {data.items.slice(0, 8).map(n => (
            <div key={n.id} className={`p-3 rounded-lg text-sm ${n.read ? "" : "bg-[#FF1E27]/10"}`} data-testid={`notif-${n.id}`}>
              <div className="font-semibold">{n.title}</div>
              <div className="text-xs text-slate-400 mt-0.5">{n.body}{n.count > 1 && <span className="ml-1 px-1 rounded bg-white/10">×{n.count}</span>}</div>
              <div className="text-[10px] font-mono-rl text-slate-600 mt-1">{new Date(n.at).toLocaleString("it-IT")}</div>
            </div>
          ))}
          <div className="flex justify-between p-2 border-t border-white/5 text-[11px] font-mono-rl"><Link to="/notifications" onClick={() => setOpen(false)} className="text-[#FF9F0A]" data-testid="notif-open-center">CENTRO NOTIFICHE</Link><Link to="/settings/notifications" onClick={() => setOpen(false)} className="text-slate-400" data-testid="notif-open-settings">PREFERENZE</Link></div>
        </div>
      )}
    </div>
  );
}
